import React, {Component} from 'react';
import {NavBar, Modal, Toast} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
import TestCode from "../../../../components/TestCode";
import {walletBindinQguery} from "../../../../service/homeService"
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class BankCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bankData:[],
            codeModal:false,
        };
    }
    componentDidMount(){
        Toast.loading("",30);
        walletBindinQguery({source:1,token:this.props.userInfo.token,}).then((res)=>{
            if(res.data.code === '0000'){
                Toast.hide();
                this.setState({bankData:res.data.data})
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    relieve(){
        this.setState({codeModal:true});
    }
    onClose = () => {
        this.setState({codeModal:false});
    };
    codeSubmit(v){
        this.setState({codeModal:false});
        console.log(3333,v)
        Modal.alert('解绑成功！', '已成功解除银行卡绑定', [
            { text: '知道了', onPress: () => console.log('ok') },
        ])
    }
    render(){
        return(
            <div className="bankCard">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >银行卡管理</NavBar>
                <div className="content">
                    {
                        this.state.bankData.map((res,i)=>(
                            <div className="tops" key={i}>
                                <div className="topTitle">
                                    <div className="topBox">
                                        <i className="icon iconfont iconyinlianchunse"/>
                                        <div>
                                            <p className="bank">{res.bankName}</p>
                                            <p>储蓄卡</p>
                                        </div>
                                    </div>
                                    {/*<div className="jiechu" onClick={()=>this.relieve()}>解除绑定</div>*/}
                                </div>
                                <p className="cardId">{res.bankNumber.substr(0,4)}***********{res.bankNumber.substr(15)}</p>
                            </div>
                        ))
                    }
                    <div className="listBox" onClick={()=>this.props.history.push(`/addBankCard`)}>
                        <div>
                            <i className="icon iconfont iconwojiajia"/>
                            <span>添加新的银行卡</span>
                        </div>
                        <i className="icon iconfont icontiaozhuan2"/>
                    </div>
                </div>

                <TestCode
                    modal={this.state.codeModal}
                    onClose={this.onClose.bind(this)}
                    codeSubmit={this.codeSubmit.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Wallet/BankCard/index.js